"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var locale = {
    alert: {
        close: 'Fechar',
    },
    calendar: {
        nextMonth: 'Próximo mês',
        previousMonth: 'Mês anterior',
        nextYear: 'Próximo ano',
        previousYear: 'Ano anterior',
    },
    dateInput: {
        placeholder: 'dd/mm/aaaa',
    },
    formControl: {
        required: 'Campo obrigatório',
    },
    input: {
        clear: 'Limpar',
    },
    modal: {
        close: 'Fechar',
    },
    monthPaginator: {
        close: 'Fechar',
        show: 'Mostrar meses',
    },
    paginator: {
        of: 'de',
        previousPage: 'Página anterior',
        nextPage: 'Próxima página',
        currentPage: 'Página atual',
    },
    dateRangeField: {
        separator: 'até',
    },
    select: {
        createItem: 'Selecione um item ou digite um novo valor',
        emptyItem: 'Nenhum resultado encontrado',
        loadingItem: 'Carregando...',
        removeItem: 'Remover',
    },
    tableFooter: {
        results: {
            zero: 'resultados',
            one: 'resultado',
            other: 'resultados',
        },
    },
};
exports.default = locale;
//# sourceMappingURL=pt-BR.js.map